import { createSettingsAdapter } from "@/pages/IntegrationsPage/components/molecules/CheckboxSettingsGroup"

import type { TicketingNotificationSettings } from "."

export const { toGroupedValues, fromGroupedValues } = createSettingsAdapter<
  keyof TicketingNotificationSettings
>([
  {
    key: "resolved",
    values: [
      { value: "comment", field: "commentOnResolved" },
      { value: "label", field: "labelOnResolved" }
    ]
  },
  {
    key: "dismissed",
    values: [
      { value: "comment", field: "commentOnDismissed" },
      { value: "label", field: "labelOnDismissed" },
      { value: "undismissedComment", field: "commentOnUndismissed" },
      { value: "undismissedLabel", field: "labelOnUndismissed" }
    ]
  },
  {
    key: "riskChange",
    values: [{ value: "comment", field: "commentOnRiskChange" }]
  }
])
